/** Intenal Import */
import CSS      from "./Answer.module.css";
import Overlay  from "@/Component/Elements/Overlay/Overlay";

interface it_AnswerProps {
    isOpen: boolean;
    onClose: () => void;
    detailTitle: string;
    postAuthor: string;
    status: "답변완료" | "답변대기";
    postDate: string;
    inquiryBody: string;
    answerBody: string;
    answerInsertDtm: string;
}





function Answer(iProps: it_AnswerProps) {
    return (
        <Overlay
            isOverlayOpen={iProps.isOpen}
            overlayCloseHandler={iProps.onClose}
        >
            <div className={CSS.PostDetailPopup}>
                <div className={CSS.PostDetailTopBar}>
                    <h3 className={CSS.PostDetailHeading}>문의 내용</h3>
                </div>

                <div className={CSS.PostDetailSection}>
                    <div className={CSS.PostDetailInfoRow}>
                        <span className={CSS.PostDetailDate}>
                            {iProps.postDate}
                        </span>

                        <span
                            className={[
                                CSS.PostDetailStatusBadge,
                                iProps.status === "답변완료" ? CSS.StatusDone : CSS.StatusPending,
                            ].join(" ")}
                        >
                            {iProps.status}
                        </span>
                    </div>

                    <div className={CSS.PostDetailInquiryBody}>
                        {iProps.inquiryBody}
                    </div>
                </div>

                <div className={CSS.PostDetailAnswerCard}>
                    <div className={CSS.PostDetailAnswerHeader}>
                        <div className={CSS.PostDetailAnswerTitleWrap}>
                            <span className={CSS.PostDetailAnswerTitle}>답변</span>
                        </div>
                        <span className={CSS.PostDetailDate}>
                            {iProps.answerInsertDtm}
                        </span>
                    </div>

                    <div className={CSS.PostDetailBody}>
                        {iProps.answerBody}
                    </div>
                </div>
            </div>
        </Overlay>
    );
}

export default Answer;
